module.exports = __webpack_public_path__ + "assets/img/driver-btn-a5945ac1.png";